
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputDevicesGoogle as ObiInputDevicesGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-devices-google.js';
 
 
 

 
 export const ObiInputDevicesGoogle = createComponent({
   react: React,
   tagName: 'obi-input-devices-google',
   elementClass: ObiInputDevicesGoogleElement,
   events: {
     
   }
  });
 
 